import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'RecordCartItem',
  components: {
    ShButton,
  },
  props: {
    record: {
      type: Object,
      default: (() => {
      }),
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    removeFromCart() {
      this.$store.commit('record/REMOVE_FROM_RECORDS_CART', this.record);
      this.$message({
        showClose: true,
        message: 'Paczka usunięta z koszyka',
        type: 'success',
      });
    },
  },
};
